// $(document).ready(function(){
//   // 容量確認ボタンを押下時
//   $('.capacity_input_btn').click(async function(e) {
//     // e.preventDefault();
//     // エラーメッセージの初期化
//     $('#capacity_input_imei_value').removeClass('capacity_input_imei_value_error');
//     $("#capacity_input_btn_error_message p").remove();
//     $('.capacity_input_btn').prop('disabled', true);
//     $('.capacity_input_btn').text('');
//     $('.capacity_input_btn').append('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');
//     const imeiValue = $('#capacity_input_imei_value').val();
//     // 入力エラーチェック
//     if (imeiValue.match(/[0-9]+/g) != imeiValue ){
//         $('#capacity_input_imei_value').addClass('capacity_input_imei_value_error');
// 		$("#capacity_input_btn_error_message").append("<p><i class=\"fa fa-exclamation-triangle\"></i>13桁の数字を入力してください。</p>");
//         $('.capacity_input_btn').empty();
//         $('.capacity_input_btn').prop('disabled', false);
//         $('.capacity_input_btn').text('確認');
// 		return false;
// 	} else if (imeiValue.length < 13) {
//         $('#capacity_input_imei_value').addClass('capacity_input_imei_value_error');
// 		$("#capacity_input_btn_error_message").append("<p><i class=\"fa fa-exclamation-triangle\"></i>13桁の数字を入力してください。</p>");
// 		$('.capacity_input_btn').empty();
//         $('.capacity_input_btn').prop('disabled', false);
//         $('.capacity_input_btn').text('確認');
// 		return false;
//     }
    
//     if(imeiValue.length === 13) {
//       // テーブル表示の初期化
//       $('.total-capacity-gb-display').text('-GB/-GB');
//       $("#japan-tab-pane tbody.responsive-table__body").empty();
//       $("#overseas-tab-pane tbody.responsive-table__body").empty();
//       $("#overseas-tab2-pane tbody.responsive-table__body").empty();
//       $('#japan-tab-pane .progress-bar').css('width', '0%');
//       $('#japan-tab-pane .progress').attr('aria-valuenow', '0');

//       const capacityResult = await (await fetch(`https://u4mjwso6r24iu4pu2rss4r7ha40xbqaj.lambda-url.ap-northeast-1.on.aws/?sn=${imeiValue}`)).json();
//       if(capacityResult == null) {
//         $('#capacity_input_imei_value').addClass('capacity_input_imei_value_error');
//         $("#capacity_input_btn_error_message").append("<p><i class=\"fa fa-exclamation-triangle\"></i>正しいSNを入力してください。</p>");
//         $('.capacity_input_btn').empty();
//         $('.capacity_input_btn').prop('disabled', false);
//         $('.capacity_input_btn').text('確認');
//       }

//       let japanTotalCapacity = 0;
//       let japanTotalRemainingCapacity = 0;
//       capacityResult.japanCapacityList.forEach( capacity => {
//         japanTotalCapacity += capacity.dataTotal;
//         japanTotalRemainingCapacity += capacity.surplusFlowbyte * 100;
//         let planNameDisplay = capacity.plan;
//         if(planNameDisplay == undefined) planNameDisplay = '';
//         if(capacity.status === 'INUSE') {
//           $("#japan-tab-pane tbody.responsive-table__body").append(`<tr class="responsive-table__row">
//                       <td class="responsive-table__body__text responsive-table__body__text--name">
//                           <span class="status-indicator status-indicator--active"></span>${capacity.countryName}
//                       </td>
//                       <td class="responsive-table__body__text responsive-table__body__text--remaining-capacity">${capacity.surplusFlowbyte}GB</td>
//                       <td class="responsive-table__body__text responsive-table__body__text--plan">${planNameDisplay}</td>
//                       <td class="responsive-table__body__text responsive-table__body__text--effective-date">${capacity.effectiveDate}</td>
//                   </tr>`);
//         } else if(capacity.status === 'ACTIVATED' || capacity.status === 'NOTACTIVE') {
//           $("#japan-tab-pane tbody.responsive-table__body").append(`<tr class="responsive-table__row">
//                       <td class="responsive-table__body__text responsive-table__body__text--name">
//                           <span class="status-indicator status-indicator--inactive"></span>${capacity.countryName}
//                       </td>
//                       <td class="responsive-table__body__text responsive-table__body__text--remaining-capacity">${capacity.surplusFlowbyte}GB</td>
//                       <td class="responsive-table__body__text responsive-table__body__text--plan">${planNameDisplay}</td>
//                       <td class="responsive-table__body__text responsive-table__body__text--effective-date">${capacity.effectiveDate}</td>
//                   </tr>`);
//         }
//       });

//       capacityResult.overseasCapacityList.forEach( capacity => {
//         let planNameDisplay = capacity.plan;
//         if(planNameDisplay == undefined) planNameDisplay = '';
//         if(capacity.status === 'INUSE') {
//           $("#overseas-tab2-pane tbody.responsive-table__body").append(`<tr class="responsive-table__row">
//                       <td class="responsive-table__body__text responsive-table__body__text--name">
//                           <span class="status-indicator status-indicator--active"></span>${capacity.countryName}
//                       </td>
//                       <td class="responsive-table__body__text responsive-table__body__text--remaining-capacity">${capacity.surplusFlowbyte}GB</td>
//                       <td class="responsive-table__body__text responsive-table__body__text--plan">${planNameDisplay}</td>
//                       <td class="responsive-table__body__text responsive-table__body__text--effective-date">${capacity.effectiveDate}</td>
//                   </tr>`);
//         } else if(capacity.status === 'ACTIVATED' || capacity.status === 'NOTACTIVE') {
//           $("#overseas-tab2-pane tbody.responsive-table__body").append(`<tr class="responsive-table__row">
//                       <td class="responsive-table__body__text responsive-table__body__text--name">
//                           <span class="status-indicator status-indicator--inactive"></span>${capacity.countryName}
//                       </td>
//                       <td class="responsive-table__body__text responsive-table__body__text--remaining-capacity">${capacity.surplusFlowbyte}GB</td>
//                       <td class="responsive-table__body__text responsive-table__body__text--plan">${planNameDisplay}</td>
//                       <td class="responsive-table__body__text responsive-table__body__text--effective-date">${capacity.effectiveDate}</td>
//                   </tr>`);
//         }
//       });

//       capacityResult.japanCapacityUsedList.forEach( capacity => {
//         let planNameDisplay = capacity.plan;
//         if(planNameDisplay == undefined) planNameDisplay = '';
//           $("#overseas-tab-pane tbody.responsive-table__body").append(`<tr class="responsive-table__row">
//           				<td class="responsive-table__body__text responsive-table__body__text--name">
//           					${capacity.countryName}
//           				</td>
//           				<td class="responsive-table__body__text responsive-table__body__text--plan">${planNameDisplay}</td>
//           				<td class="responsive-table__body__text responsive-table__body__text--effective-date">${capacity.effectiveDate}</td>
//           			</tr>`);
//       });

//       $('.total-capacity-gb-display').text(`${japanTotalRemainingCapacity / 100}GB/${japanTotalCapacity}GB`);
//       const remainingCapacityRate = Math.round((japanTotalRemainingCapacity / 100) / japanTotalCapacity * 100);
//       $('#japan-tab-pane .progress-bar').css('width', `${remainingCapacityRate}%`);
//       $('#japan-tab-pane .progress').attr('aria-valuenow', remainingCapacityRate);
//     }
    
//     $('.capacity_input_btn').empty();
//     $('.capacity_input_btn').prop('disabled', false);
//     $('.capacity_input_btn').text('確認');
//   });

//   $("#capacity_input_imei_value").bind("blur", function() {
// 		let _textbox = $(this).val();
// 		check_imei_textbox(_textbox);
// 	});
// });

// function check_imei_textbox(str){
//     $('#capacity_input_imei_value').removeClass('capacity_input_imei_value_error');
//     $("#capacity_input_btn_error_message p").remove();
// 	$("#capacity_check_error_textbox p").remove();
// 	var _result = true;
// 	var _textbox = $.trim(str);

// 	if (_textbox.match(/[0-9]+/g) != _textbox ){
//         $('#capacity_input_imei_value').addClass('capacity_input_imei_value_error');
// 		$("#capacity_input_btn_error_message").append("<p><i class=\"fa fa-exclamation-triangle\"></i>13桁の数字を入力してください。</p>");
// 		_result = false;
// 	} else if (_textbox.length < 13) {
//         $('#capacity_input_imei_value').addClass('capacity_input_imei_value_error');
// 		$("#capacity_input_btn_error_message").append("<p><i class=\"fa fa-exclamation-triangle\"></i>13桁の数字を入力してください。</p>");
// 		_result = false;
//     }
// 	return _result;
// }









$(document).ready(function () {
  let isLoading = false;
  // 容量確認ボタンを押下時
  $('.capacity_input_btn').click(async function () {
    if (isLoading) return;

    const $button = $('.capacity_input_btn');
    const $input = $('#capacity_input_imei_value');
    const $error = $('#capacity_input_btn_error_message');

    try {
      isLoading = true;

      $input.removeClass('capacity_input_imei_value_error');
      $("#capacity_input_btn_error_message p").remove();

      $button.prop('disabled', true);
      $button.empty();
      $button.append('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');

      const imeiValue = $.trim($input.val());

      if (!/^\d{13}$/.test(imeiValue)) {
        $input.addClass('capacity_input_imei_value_error');
        $error.append('<p><i class="fa fa-exclamation-triangle"></i>13桁の数字を入力してください。</p>');
        return;
      }

      $('.total-capacity-gb-display').text('-GB/-GB');
      $("#japan-tab-pane tbody.responsive-table__body").empty();
      $("#overseas-tab-pane tbody.responsive-table__body").empty();
      $("#overseas-tab2-pane tbody.responsive-table__body").empty();
      $('#japan-tab-pane .progress-bar').css('width', '0%');
      $('#japan-tab-pane .progress').attr('aria-valuenow', '0');

      const response = await fetch(
        `https://u4mjwso6r24iu4pu2rss4r7ha40xbqaj.lambda-url.ap-northeast-1.on.aws/?sn=${encodeURIComponent(imeiValue)}`
      );

      let capacityResult = null;
      try {
        capacityResult = await response.json();
      } catch (jsonError) {
        capacityResult = null;
      }

      if (response.status === 429) {
        $input.addClass('capacity_input_imei_value_error');
        $error.append('<p><i class="fa fa-exclamation-triangle"></i>現在アクセスが集中しています。少し時間を空けて再度お試しください。</p>');
        return;
      }

      if (!response.ok || !capacityResult?.success) {
        $input.addClass('capacity_input_imei_value_error');
        $error.append(
          `<p><i class="fa fa-exclamation-triangle"></i>${capacityResult?.message || '容量確認に失敗しました。'}</p>`
        );
        return;
      }

      let japanTotalCapacity = 0;
      let japanTotalRemainingCapacity = 0;

      (capacityResult.japanCapacityList || []).forEach((capacity) => {
        japanTotalCapacity += Number(capacity.dataTotal || 0);
        japanTotalRemainingCapacity += Number(capacity.surplusFlowbyte || 0) * 100;

        const planNameDisplay = capacity.plan || '';

        if (capacity.status === 'INUSE') {
          $("#japan-tab-pane tbody.responsive-table__body").append(`
            <tr class="responsive-table__row">
              <td class="responsive-table__body__text responsive-table__body__text--name">
                <span class="status-indicator status-indicator--active"></span>${capacity.countryName}
              </td>
              <td class="responsive-table__body__text responsive-table__body__text--remaining-capacity">${capacity.surplusFlowbyte}GB</td>
              <td class="responsive-table__body__text responsive-table__body__text--plan">${planNameDisplay}</td>
              <td class="responsive-table__body__text responsive-table__body__text--effective-date">${capacity.effectiveDate}</td>
            </tr>
          `);
        } else if (capacity.status === 'ACTIVATED' || capacity.status === 'NOTACTIVE') {
          $("#japan-tab-pane tbody.responsive-table__body").append(`
            <tr class="responsive-table__row">
              <td class="responsive-table__body__text responsive-table__body__text--name">
                <span class="status-indicator status-indicator--inactive"></span>${capacity.countryName}
              </td>
              <td class="responsive-table__body__text responsive-table__body__text--remaining-capacity">${capacity.surplusFlowbyte}GB</td>
              <td class="responsive-table__body__text responsive-table__body__text--plan">${planNameDisplay}</td>
              <td class="responsive-table__body__text responsive-table__body__text--effective-date">${capacity.effectiveDate}</td>
            </tr>
          `);
        }
      });

      (capacityResult.overseasCapacityList || []).forEach((capacity) => {
        const planNameDisplay = capacity.plan || '';

        if (capacity.status === 'INUSE') {
          $("#overseas-tab2-pane tbody.responsive-table__body").append(`
            <tr class="responsive-table__row">
              <td class="responsive-table__body__text responsive-table__body__text--name">
                <span class="status-indicator status-indicator--active"></span>${capacity.countryName}
              </td>
              <td class="responsive-table__body__text responsive-table__body__text--remaining-capacity">${capacity.surplusFlowbyte}GB</td>
              <td class="responsive-table__body__text responsive-table__body__text--plan">${planNameDisplay}</td>
              <td class="responsive-table__body__text responsive-table__body__text--effective-date">${capacity.effectiveDate}</td>
            </tr>
          `);
        } else if (capacity.status === 'ACTIVATED' || capacity.status === 'NOTACTIVE') {
          $("#overseas-tab2-pane tbody.responsive-table__body").append(`
            <tr class="responsive-table__row">
              <td class="responsive-table__body__text responsive-table__body__text--name">
                <span class="status-indicator status-indicator--inactive"></span>${capacity.countryName}
              </td>
              <td class="responsive-table__body__text responsive-table__body__text--remaining-capacity">${capacity.surplusFlowbyte}GB</td>
              <td class="responsive-table__body__text responsive-table__body__text--plan">${planNameDisplay}</td>
              <td class="responsive-table__body__text responsive-table__body__text--effective-date">${capacity.effectiveDate}</td>
            </tr>
          `);
        }
      });

      (capacityResult.japanCapacityUsedList || []).forEach((capacity) => {
        const planNameDisplay = capacity.plan || '';

        $("#overseas-tab-pane tbody.responsive-table__body").append(`
          <tr class="responsive-table__row">
            <td class="responsive-table__body__text responsive-table__body__text--name">${capacity.countryName}</td>
            <td class="responsive-table__body__text responsive-table__body__text--plan">${planNameDisplay}</td>
            <td class="responsive-table__body__text responsive-table__body__text--effective-date">${capacity.effectiveDate}</td>
          </tr>
        `);
      });

      $('.total-capacity-gb-display').text(`${japanTotalRemainingCapacity / 100}GB/${japanTotalCapacity}GB`);

      const remainingCapacityRate =
        japanTotalCapacity > 0
          ? Math.round(((japanTotalRemainingCapacity / 100) / japanTotalCapacity) * 100)
          : 0;

      $('#japan-tab-pane .progress-bar').css('width', `${remainingCapacityRate}%`);
      $('#japan-tab-pane .progress').attr('aria-valuenow', remainingCapacityRate);

    } catch (error) {
      console.error('capacity-check error', error);
      $input.addClass('capacity_input_imei_value_error');
      $error.append('<p><i class="fa fa-exclamation-triangle"></i>通信エラーが発生しました。時間を空けて再度お試しください。</p>');
    } finally {
      isLoading = false;
      $button.empty();
      $button.prop('disabled', false);
      $button.text('確認');
    }
  });

  $("#capacity_input_imei_value").on("blur", function () {
    check_imei_textbox($(this).val());
  });
});

function check_imei_textbox(str) {
  $('#capacity_input_imei_value').removeClass('capacity_input_imei_value_error');
  $("#capacity_input_btn_error_message p").remove();
  $("#capacity_check_error_textbox p").remove();

  const textbox = $.trim(str);

  if (!/^\d{13}$/.test(textbox)) {
    $('#capacity_input_imei_value').addClass('capacity_input_imei_value_error');
    $("#capacity_input_btn_error_message").append('<p><i class="fa fa-exclamation-triangle"></i>13桁の数字を入力してください。</p>');
    return false;
  }

  return true;
}